import { Component, Suspense, lazy /*, useEffect*/ } from "react";
import { Routes, Route, Navigate } from "react-router";
// import { useLocation } from "react-router";
// import {
//   MsalAuthenticationTemplate,
//   MsalProvider,
//   useMsal,
// } from "@azure/msal-react";
// import { EventType, InteractionType } from "@azure/msal-browser";

//import { b2cPolicies, loginRequest, AuthLoading, AuthError } from "./auth";
import {
  Layout,
  //LoggedOut,
  ErrorBoundary,
  GlobalError,
  logError,
  Loading,
} from "./layout";
//import { Watchlists } from "./watchlists";
//import { Home } from "./home";

import "./app.css";

/**
 * Lazy-loads the named export `name` of a module, for route-based code splitting.
 */
const lazyNamed = (load, name) => lazy(() => load().then((module) => ({ default: module[name] })));

const Stocks = lazyNamed(() => import("./stocks/list"), "Stocks");
const Stock = lazyNamed(() => import("./stocks/details"), "Stock");
const Sectors = lazyNamed(() => import("./sectors/list"), "Sectors");
const Indexes = lazyNamed(() => import("./indexes/list"), "Indexes");
const MarketInsights = lazyNamed(() => import("./insights/pages"), "MarketInsights");
const SectorInsights = lazyNamed(() => import("./insights/pages"), "SectorInsights");
const IndustryInsights = lazyNamed(() => import("./insights/pages"), "IndustryInsights");
const IndexInsights = lazyNamed(() => import("./insights/pages"), "IndexInsights");
const LegalPage = lazyNamed(() => import("./legal"), "LegalPage");

const Content = () => {
  //const location = useLocation();

  /**
   * useMsal is hook that returns the PublicClientApplication instance,
   * an array of all accounts currently signed in and an inProgress value
   * that tells you what msal is currently doing. For more, visit:
   * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/hooks.md
   */
  //   const { instance } = useMsal();
  //   const authRequest = { ...loginRequest };

  /**
   * Using the event API, you can register an event callback that will do something when an event is emitted.
   * When registering an event callback in a react component you will need to make sure you do 2 things.
   * 1) The callback is registered only once
   * 2) The callback is unregistered before the component unmounts.
   * For more, visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/events.md
   */
  //   useEffect(() => {
  //     const callbackId = instance.addEventCallback((event) => {
  //       if (event.eventType === EventType.LOGIN_FAILURE) {
  //         if (
  //           event.error &&
  //           event.error.errorMessage.indexOf("AADB2C90118") > -1
  //         ) {
  //           if (event.interactionType === InteractionType.Redirect) {
  //             instance.loginRedirect(b2cPolicies.authorities.forgotPassword);
  //           } else if (event.interactionType === InteractionType.Popup) {
  //             instance
  //               .loginPopup(b2cPolicies.authorities.forgotPassword)
  //               .catch((e) => {
  //                 return;
  //               });
  //           }
  //         }
  //       }

  //       if (
  //         event.eventType === EventType.LOGIN_SUCCESS ||
  //         event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS
  //       ) {
  //         if (event?.payload) {
  //           /**
  //            * We need to reject id tokens that were not issued with the default sign-in policy.
  //            * "acr" claim in the token tells us what policy is used (NOTE: for new policies (v2.0), use "tfp" instead of "acr").
  //            * To learn more about B2C tokens, visit https://docs.microsoft.com/en-us/azure/active-directory-b2c/tokens-overview
  //            */
  //           if (
  //             event.payload.idTokenClaims["acr"] ===
  //             b2cPolicies.names.forgotPassword
  //           ) {
  //             window.alert(
  //               "Password has been reset successfully. \nPlease sign-in with your new password."
  //             );
  //             return instance.logout();
  //           } else if (
  //             event.payload.idTokenClaims["acr"] === b2cPolicies.names.editProfile
  //           ) {
  //             window.alert(
  //               "Profile has been edited successfully. \nPlease sign-in again."
  //             );
  //             return instance.logout();
  //           }
  //         }
  //       }
  //     });

  //     return () => {
  //       if (callbackId) {
  //         instance.removeEventCallback(callbackId);
  //       }
  //     };
  //   }, [instance]);

  // if (location.pathname === '/loggedout') {
  //     return (
  //         <Layout>
  //             <Routes>
  //                 <Route path='/loggedout' element={<LoggedOut />} />
  //             </Routes>
  //         </Layout>
  //     );
  // }

  // return (
  //     <Layout>
  //         <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={authRequest} loadingComponent={AuthLoading} errorComponent={AuthError}>
  //             <ErrorBoundary FallbackComponent={GlobalError} onError={logError}>
  //                 <Routes>
  //                     <Route path='/' element={<Home />} />
  //                     <Route path='/stocks' element={<Stocks />} />
  //                     <Route path='/stocks/:id/*' element={<Stock />} />
  //                     <Route path='/watchlists' element={<Watchlists />} />
  //                 </Routes>
  //             </ErrorBoundary>
  //         </MsalAuthenticationTemplate>
  //     </Layout>
  // );

  return (
    <Layout>
      <ErrorBoundary FallbackComponent={GlobalError} onError={logError}>
        <Suspense fallback={<Loading text="page" />}>
          <Routes>
            <Route path="/" element={<Navigate to="/market" replace />} />
            <Route path="/stocks" element={<Stocks />} />
            <Route path="/stocks/page/:page" element={<Stocks />} />
            <Route path="/stocks/:id/*" element={<Stock />} />
            <Route path="/sectors" element={<Sectors />} />
            <Route path="/sectors/:sectorId" element={<SectorInsights />} />
            <Route path="/sectors/:sectorId/industries/:industryId" element={<IndustryInsights />} />
            <Route path="/market" element={<MarketInsights />} />
            <Route path="/indexes" element={<Indexes />} />
            <Route path="/indexes/:indexId" element={<IndexInsights />} />
            <Route path="/legal/:pageId" element={<LegalPage />} />
          </Routes>
        </Suspense>
      </ErrorBoundary>
    </Layout>
  );
};

export default class App extends Component {
  render() {
    return (
      <>
        {/* <MsalProvider instance={this.props.instance}>
                    <Content />
                </MsalProvider> */}
        <Content />
      </>
    );
  }
}
